<div class="relative">
  <button type="button" (click)="toggleOpen()"
    class="flex h-11 w-full items-center justify-between rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-left shadow-theme-xs transition-colors focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:focus:border-brand-800 {{ className }}"
    [ngClass]="value ? 'text-gray-800 dark:text-white/90' : 'text-gray-400 dark:text-gray-400'">
    <span class="truncate">{{ selectedLabel || placeholder }}</span>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
      class="flex-shrink-0 text-gray-700 dark:text-gray-400 transition-transform duration-200"
      [class.rotate-180]="isOpen">
      <path d="M4.79175 8.02075L10.0001 13.2291L15.2084 8.02075" stroke="currentColor" stroke-width="1.5"
        stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </button>

  <div *ngIf="isOpen"
    class="absolute left-0 right-0 top-full mt-2 z-50 rounded-2xl border border-[#e8e8e8] bg-white shadow-theme-lg overflow-hidden dark:border-gray-800 dark:bg-gray-900">

    <div class="p-2 border-b border-[#f0f0f0] dark:border-gray-800">
      <div class="relative">
        <input type="text" [(ngModel)]="searchText" (ngModelChange)="onSearchInput($event)"
          [placeholder]="searchPlaceholder"
          class="w-full rounded-full border border-[#e8e8e8] bg-[#fafafa] px-4 py-2 pr-9 text-sm text-gray-700 placeholder-gray-400 outline-none focus:border-[#D31148] focus:ring-1 focus:ring-[#D31148] transition-colors dark:bg-gray-800 dark:text-white/90" />
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
          class="absolute text-gray-400 right-3 top-1/2 -translate-y-1/2 pointer-events-none">
          <path
            d="M21 21L17.5001 17.5M20 11.5C20 16.1944 16.1944 20 11.5 20C6.80558 20 3 16.1944 3 11.5C3 6.80558 6.80558 3 11.5 3C16.1944 3 20 6.80558 20 11.5Z"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>

    <div class="max-h-[200px] overflow-y-auto">
      <button *ngFor="let option of filteredOptions" type="button" (click)="selectOption(option)"
        class="flex w-full items-center px-4 py-2.5 text-left text-sm transition-colors hover:bg-gray-50 dark:hover:bg-white/5"
        [class.bg-rose-50]="option.value === value"
        [class.text-[#D31148]]="option.value === value"
        [class.font-semibold]="option.value === value"
        [class.text-gray-700]="option.value !== value"
        [class.dark:text-gray-300]="option.value !== value">
        {{ option.label }}
      </button>

      <div *ngIf="filteredOptions.length === 0" class="px-4 py-6 text-center text-sm text-gray-400">
        No matches found
      </div>
    </div>
  </div>
</div>
